import { Pipe, PipeTransform } from '@angular/core';
import { EFareType } from "libraries/service/resources/airTrip/IGetAirTripQuotes";

@Pipe({
    name: 'isFaretypePipe'
})

export class IsFaretypePipe implements PipeTransform {
    public transform(value: EFareType | EFareType[], toCompare: EFareType): boolean {
        if(Array.isArray(value)){
            return value.includes(toCompare);
        }

        return value === toCompare;
    }
}
